interface Properties {
  siteKey: string;
  baseURL: string;
  invalid_email_msg: string;
  invalid_resetPassword_input: string;
  password_criteria_error: string;
  passwordLength_error: string;
  passwordMismatch_error: string;
  headerFragmentUrl: string;
  footerFragmentUrl: string;
  apiEndpoint: string;
  resetPasswordApiEndpoint: string;
  forgotPasswordSuccessMessage: string;
  resetPasswordSuccessMessage: string;
  aemBaseUrl: string;
  siteConfigApiUrl: string;
  forgotPasswordEndpointTemplate: string;
  resetPasswordEndpointTemplate: string;
}
export const properties: Properties = {
  siteKey: process.env.REACT_APP_SITE_KEY as string,
  siteConfigApiUrl: process.env.REACT_APP_SITE_CONFIG_API_URL as string,
  baseURL: process.env.REACT_APP_BASE_URL as string,
  aemBaseUrl: process.env.REACT_APP_AEM_RESOURCE_BASE_URL as string, //for header-footer
  invalid_email_msg: "Your Email Address was incorrect",
  invalid_resetPassword_input: "Please enter a valid password.",
  password_criteria_error: "Please check Password Criteria.",
  passwordLength_error: "Password must be at least 10 digits",
  passwordMismatch_error: "Passwords do not match.  Please try again",
  forgotPasswordEndpointTemplate: "%domain%/v1/forgotpassword",
  resetPasswordEndpointTemplate: "%domain%/v1/resetpassword",
  headerFragmentUrl: process.env.REACT_APP_HEADER_URL as string,
  footerFragmentUrl: process.env.REACT_APP_FOOTER_URL as string,
  apiEndpoint: (process.env.REACT_APP_BASE_URL +
    "/v1/forgotpassword") as string,
  resetPasswordApiEndpoint: (process.env.REACT_APP_BASE_URL +
    "/v1/resetpassword") as string,
  forgotPasswordSuccessMessage:
    "Password reset instructions have been sent to your e-mail address.",
  resetPasswordSuccessMessage: "Your password has been changed.",
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getLocale = () => {
  const curLocale = window.location.pathname.replace(/^\/([^\/]*).*$/, "$1");
  return curLocale;
};

export const LoadInlineScript = (script: string) => {
  const externalScript = document.createElement("script");
  externalScript.appendChild(document.createTextNode(script));
  document.head.appendChild(externalScript);
};

// Resolves on load/error so callers can actually await script readiness
export const LoadExternalScript = (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const externalScript = document.createElement("script");
    externalScript.type = "text/javascript";
    externalScript.src = url;
    externalScript.onload = () => resolve();
    externalScript.onerror = () =>
      reject(new Error(`Failed to load script: ${url}`));
    document.head.appendChild(externalScript);
  });
};
